import Tooltip from "@/components/Tooltip"
import cn from "@/utils/cn"
import { ComponentPropsWithRef } from "react"

type ReminderStatusBadgeProps = {
  active: boolean
} & ComponentPropsWithRef<"div">

const ReminderStatusBadge = ({
  active,
  className,
  ...otherProps
}: ReminderStatusBadgeProps) => (
  <div className={cn("inline-block", className)} {...otherProps}>
    <Tooltip content="Reminders are only sent when the patient has an active hypertension prescription.">
      <span
        className={cn(
          "cursor-default rounded-full border px-3 py-1 text-xs font-semibold",
          active
            ? "border-blue-200 bg-blue-100 text-blue-700"
            : "border-gray-200 bg-gray-100 text-gray-500"
        )}
      >
        {active ? "Active" : "Inactive"}
      </span>
    </Tooltip>
  </div>
)

export default ReminderStatusBadge
